import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

/**
* @desc skills tab content in candidate profile section
* @param props
* @return DOMElement
*/

const Skills = (props) => {
  return (
    <Col xs={12} md={4} className="candidate-skills tab-body">          
          {/* <span class="skills-con">{props.skill.skill.substr(0,35)} {(props.skill.skill && props.skill.skill.length > 35) ? "...": null}</span>          
          {(props.skill.skill && props.skill.skill.length > 35) ?
            <div class='tooltip'>
              {props.skill.skill}
            </div>
          : null} */}
          <span class="skills-con" >{props.skill.skill?props.skill.skill:null}</span>                  
    </Col>
  );
}

export default Skills;


// WEBPACK FOOTER //
// ./src/components/Client/Skills/skills.js